import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  /** Rendered text comes from the caller so the boundary itself needs no i18n hook. */
  message: string;
  reloadLabel: string;
  children: ReactNode;
}

/** Last line of defence: a crash shows a calm message instead of a blank page. */
export class ErrorBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="center-page">
        <p>{this.props.message}</p>
        <button className="btn btn-primary" onClick={() => location.reload()}>
          {this.props.reloadLabel}
        </button>
      </main>
    );
  }
}
